// extracted by mini-css-extract-plugin
export default {"sidebar":"SideBar_sidebar__v9hbf"};